import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { DutyTimeBufferAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-duty-time-buffer-audit-list',
  templateUrl: './duty-time-buffer-audit-list.component.html',
  styleUrls: ['./duty-time-buffer-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DutyTimeBufferAuditListComponent implements OnInit {
  @Input() dutyTimeBufferId: number;
  @Input() loading: boolean;
  @Input() dutyTimeBufferAudits: DutyTimeBufferAudit[];

  @Output() loadDutyTimeBuffer = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadDutyTimeBuffer.emit(this.dutyTimeBufferId);
  }

  onNextPage() {
    this.nextPage.emit(this.dutyTimeBufferId);
  }
}
